<template>
  <div>
    <!-- Main Top Navigation Bar -->
    <v-app-bar app :style="{ background: getThemeColor }" dark flat height="70">
      <!-- Hamburger Menu Toggle (Mobile & Desktop Drawer) -->
      <v-btn
        icon
        class="mr-2"
        @click="drawer = !drawer"
        dark
        v-if="getAuthenticated"
      >
        <v-icon>mdi-menu</v-icon>
      </v-btn>

      <!-- Brand / Company Name Section -->
      <v-toolbar-title
        class="font-weight-bold primary--text d-flex align-center"
      >
        <!-- <v-icon left :color="getSecondaryColor" large class="mr-2">mdi-balance-scale</v-icon> -->
        <span
          class="text-h6 font-weight-bold text-truncate"
          :style="{ 'max-width': '250px', color: getSecondaryColor }"
        >
          {{ userCompany?.name || appName || "" }}
        </span>
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Modern Actions Row -->
      <v-btn
        text
        small
        :color="getSecondaryColor"
        class="text-capitalize mr-2 d-none d-sm-flex"
        v-if="userCompany"
      >
        <v-icon left small v-if="userCompany?.primary_phone">mdi-phone</v-icon>
        {{ userCompany?.primary_phone || "" }}
      </v-btn>

      <v-btn icon color="grey darken-2" class="mr-1">
        <v-icon>mdi-bell-outline</v-icon>
      </v-btn>

      <v-avatar size="40" color="primary lighten-4">
        <v-icon color="primary">mdi-account-circle</v-icon>
      </v-avatar>
    </v-app-bar>

    <!-- Sleek Slide-out Navigation Drawer -->
    <v-navigation-drawer v-model="drawer" fixed temporary width="280">
      <!-- Drawer Header / Brand Identity -->
      <v-list-item
        class="px-4 py-5"
        dark
        :style="{ background: getThemeColor }"
      >
        <v-list-item-avatar>
          <div v-if="getAppMode === 'legal'">
            <v-icon large color="white">mdi-scale-balance</v-icon>
          </div>
          <div v-else>
            <v-icon large color="white">mdi-database</v-icon>
          </div>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="text-subtitle-1 font-weight-bold">
            {{ userCompany?.name || "Case Billing" }}
          </v-list-item-title>
          <v-list-item-subtitle class="text-caption opacity-8">
            {{ userCompany?.city || "legal-suite" }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <!-- Dynamic Navigation Menu Items -->
      <v-list nav dense class="mt-2">
        <v-list-item
          v-for="item in menu"
          :key="item.route"
          @click="linkClicked(item)"
          active-class="primary--text font-weight-medium grey lighten-4"
          :style="{ background: getThemeColor, color: 'white' }"
          class="py-1"
        >
          <v-list-item-icon class="mr-4">
            <v-icon dark>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-2">{{
              item.label
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          active-class="primary--text font-weight-medium grey lighten-4"
          class="py-1"
          :style="{ background: getThemeColor, color: 'white' }"
          v-if="getCurrentUser && getCurrentUser.email === 'adubyte2@yahoo.com'"
          @click="goToSalesDash()"
        >
          <v-list-item-icon class="mr-4">
            <v-icon dark>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-2">
              Sales Dashboard
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          active-class="primary--text font-weight-medium grey lighten-4"
          class="py-1"
          :style="{ background: getThemeColor, color: 'white' }"
        >
          <v-list-item-icon class="mr-4">
            <v-icon dark>mdi-cash-multiple</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="text-subtitle-2">
              <v-select
                outlined
                dark
                :items="currencies"
                v-model="selectedCurrency"
                label="Select Currency"
                placeholder="Select Currency"
                @change="getAndSetSelectedCurrency()"
                return-object
              ></v-select>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div v-if="editCompanyDialog && companyToBeEdited">
      <DataEntryAndEdit
        table="companies"
        :row="companyToBeEdited"
        :value="editCompanyDialog"
        @close="closeDialog"
        @saved="getUpdatedCompanyInfo"
      ></DataEntryAndEdit>
    </div>

    <div v-if="manageImagesDialog">
      <ManageImages
        :dialog="manageImagesDialog"
        @input="closeManageImagesDialog"
      ></ManageImages>
    </div>
    <FreemiumUpgradeDialog></FreemiumUpgradeDialog>
    <Loader></Loader>
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import companiesJs from "@/plugins/companies";
import currenciesJs from "@/plugins/currencies";
import Loader from "@/components/Vuetify/Loader.vue";
import DataEntryAndEdit from "@/modules/CrudDatabases/DataEntryAndEdit.vue";
import ManageImages from "@/modules/ManageImagesAndFiles/ManageImages.vue";
import FreemiumUpgradeDialog from "@/components/General/FreemiumUpgradeDialog.vue";

export default {
  name: "HeaderComponent",
  components: {
    DataEntryAndEdit,
    Loader,
    ManageImages,
    FreemiumUpgradeDialog,
  },
  props: {
    authenticated: {
      type: Boolean,
      default: false,
    },
    slug: {
      type: String,
      default: "",
    },
  },
  computed: {
    getAppName() {
      return this.$store.getters.getAppName;
    },
    getAppMode() {
      return this.$store.getters.getAppMode;
    },
    getAuthenticated() {
      return this.$store.getters.getAuthenticated;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    gradientIconStyle() {
      return this.$store.getters.gradientIconStyle;
    },
    getSecondaryColor() {
      return this.$store.getters.getSecondaryColor;
    },
  },
  data: () => ({
    userCompany: null,
    appName: null,
    drawer: false,
    currencies: [],
    selectedCurrency: null,
    editCompanyDialog: false,
    manageImagesDialog: false,
    companyToBeEdited: null,
    menu: [
      {
        label: "Update Company Info",
        icon: "mdi-cog",
        route: null,
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        authRequired: true,
        function: "openAndEditCompanyInfo",
      },
      {
        label: "Upload Company Images",
        icon: "mdi-image",
        route: null,
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        authRequired: true,
        function: "openManageImage",
      },
      {
        label: "Tickets & Enquiries",
        icon: "mdi-comment-account",
        route: null,
        alevel: [7, 8, 9, 10, 11, 12, 13, 14, 15],
        authRequired: true,
        function: "goToTicketSystem",
      },
      {
        label: "Sign Out",
        icon: "mdi-logout",
        route: null,
        alevel: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
        authRequired: true,
        function: "signOut",
      },
    ],
  }),
  watch: {
    // async getUserCompany(){
    //   await this.getCompany()
    // },
    slug(newVal) {
      if (newVal) this.determineAppState();
    },
  },
  //   async created(){

  //   const data = await this.$store.dispatch('setCompanyContext', {company: null, fresh:true});
  //   this.userCompany = data.targetCompany
  // },
  async mounted() {
    this.currencies = currenciesJs.getSupportedCurrencies();
    await this.determineAppState();
  },
  methods: {
    async determineAppState() {
      const domain = window.location.hostname;

      if (this.slug) {
        const res = await companiesJs.getCompanyBySlug(this.slug);
        if (
          res &&
          res.status === "success" &&
          (await this.setupCompanyData(res.company))
        ) {
          return;
        }
      }

      if (domain.includes("legalcasebilling")) {
        this.appName = "Legal Case Billing";
      } else if (domain.includes("bitsinvoice")) {
        this.appName = "BitsInvoice";
      } else {
        await this.getCompanyWithDomain(domain);
      }
    },
    async setupCompanyData(compData) {
      const company = compData?.company || null;
      if (!company) return false;

      this.userCompany = company;
      this.appName = company?.name || "";
      helpersJs.initialiseOrUpdateCompanyDataInStorage(null, compData);

      if (company.emis) {
        const logos = await companiesJs.getLogos(company.emis);
        if (logos?.length > 0) {
          this.logo = logos[0];
        }
      }
      return true;
    },
    async getCompanyWithDomain(domain) {
      const compData = await companiesJs.getCompanyWithDomain(domain);
      await this.setupCompanyData(compData);
    },
    goToTicketSystem() {
      if (!this.userCompany || this.userCompany.package === "freemium") {
        this.$store.commit("setUpgradeDialog", true);
        return;
      }

      const selectedCompany = this.userCompany;
      this.$store.commit("setSelectedDirectoryCompany", selectedCompany);
      this.$router.push({
        name: "contact-us",
        params: { slug: selectedCompany.slug },
      });
    },
    goToSalesDash() {
      if (
        !this.getCurrentUser ||
        this.getCurrentUser.email != "adubyte2@yahoo.com"
      ) {
        return;
      }
      this.$router.push({ name: "sales-dashboard" });
    },
    async getCompany() {
      return await companiesJs.initialiseCompanyAndLogo();
    },
    async linkClicked(item) {
      if (!item) return;
      if (!item.function || typeof this[item.function] !== "function") return;

      if (item.authRequired && !this.getAuthenticated) return;

      await this[item.function]();
    },
    async signOut() {
      helpersJs.signOut();
      this.$toast.success("User logged out successfully!", { duration: 10000 });
    },
    async openAndEditCompanyInfo() {
      this.$store.commit("setLoader", true);
      const companyData = await this.getCompany();
      this.companyToBeEdited = companyData?.company;
      this.$store.commit("setLoader", false);
      this.editCompanyDialog = true;
    },
    openManageImage() {
      if (!this.userCompany || this.userCompany.package === "freemium") {
        this.$store.commit("setUpgradeDialog", true);
        return;
      }
      this.manageImagesDialog = true;
    },
    async closeManageImagesDialog(input) {
      this.manageImagesDialog = input;
      await companiesJs.initialiseCompanyAndLogo();
    },
    async getUpdatedCompanyInfo() {
      await companiesJs.initialiseCompanyAndLogo();
      const data = await this.$store.dispatch("setCompanyContext", {
        company: null,
        fresh: true,
      });
      this.userCompany = data.targetCompany;
    },
    async closeDialog() {
      this.companyToBeEdited = null;
      this.editCompanyDialog = false;
      this.manageImagesDialog = false;
      await companiesJs.initialiseCompanyAndLogo();
    },

    async getAndSetSelectedCurrency() {
      if (!this.selectedCurrency) return;
      const companyData = this.getUserCompany;
      const currency = this.selectedCurrency.value;

      await helpersJs.updateModelSingleRow(
        "companies",
        "currency",
        companyData.company.id,
        this.selectedCurrency.value
      );
      companyData.currency = currency;
      companyData.company.currency = currency;

      const data = await this.$store.dispatch("setCompanyContext", {
        company: null,
        fresh: true,
      });
      this.userCompany = data.targetCompany;

      helpersJs.initialiseOrUpdateCompanyDataInStorage(null, companyData);
    },
  },
};
</script>

<style scoped>
/* Minor stylistic refinements */
.opacity-8 {
  opacity: 0.8;
}
</style>
